export default {
  'cashFlow.label.status': 'Situação',
  'cashFlow.label.filterByDate': 'Filtrar por data de',
  'cashFlow.label.reportType': 'Selecione o tipo de relatório',
  'cashFlow.label.show': 'Exibir:',
  'cashFlow.label.moreOptions': 'Mais Opções',
  'cashFlow.label.bankAccount': 'Conta bancária',

  'cashFlow.option.open': 'Abertos',
  'cashFlow.option.liquidated': 'Liquidados',
  'cashFlow.option.expiration': 'Vencimento',
  'cashFlow.option.payment': 'Pagamento',
  'cashFlow.option.emission': 'Emissão',
  'cashFlow.option.weekly': 'Semanal',
  'cashFlow.option.period': 'Mensal',
  'cashFlow.option.daily': 'Diário',

  'cashFlow.checkbox.synthetic': 'Sintético?',
  'cashFlow.checkbox.accPayableReceivable': 'Contas a pagar/receber',
  'cashFlow.checkbox.tariffs': 'Tarifas',
  'cashFlow.checkbox.singleRelease': 'Lançamentos avulsos',
};
